import React from 'react';
import { Box, Container, List, ListItem } from '@mui/material';
import { LocalizedButton as Button, LocalizedListItemText as ListItemText } from '../components/i18n/LocalizedMui';
import Typography from '../components/i18n/LocalizedTypography';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../components/SEO';
import KundlistarSchema from '../components/KundlistarSchema';

const KpAstrologySoftwarePage: React.FC = () => (
  <>
    <SEO
      title="Kundlistar KP Astrology Software - Cuspal, Sub Lord & Ruling Planets"
      description="Kundlistar KP astrology software helps astrologers study cusps, sub lords, significators, ruling planets, horary charts and timing insights on web and Android."
      path="/kp-astrology-software"
      keywords="Kundlistar KP astrology software, KP astrology software, cuspal sub lord, ruling planets, horary astrology, KP significators"
    />
    <KundlistarSchema />

    <Box sx={{ bgcolor: "var(--app-surface-neutral, #f7fbf8)", py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography variant="h2" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Kundlistar KP Astrology Software
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          Kundlistar supports KP astrology workflows for astrologers and serious learners, including
          cuspal analysis, sub lord interpretation, significators, ruling planets and horary charts.
        </Typography>
      </Container>
    </Box>

    <Container maxWidth="md" sx={{ py: 7 }}>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 2 }}>
        KP astrology features in Kundlistar
      </Typography>
      <List>
        {[
          'KP cuspal sub lord analysis',
          'Ruling Planets tool for timing',
          'Horary and Prashna chart workflows',
          'Sign lord, star lord and sub lord hierarchy',
          'Vedic, Nadi and BNN layers alongside KP analysis',
        ].map((item) => (
          <ListItem key={item} disableGutters>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>
      <Button component={RouterLink} to="/calculate" variant="contained" sx={{ mt: 2 }}>
        Try KP Astrology on Kundlistar
      </Button>
    </Container>
  </>
);

export default KpAstrologySoftwarePage;
